import { Navigate } from '@tanstack/react-router';
import { useUserRoles } from '@anytag/auth';
import { useUpdateDocumentTitle } from '@anytag/shared-hooks';
import { Header } from '@anytag/shared-molecules';
import { AddInfluencerForOthers } from './add-influencer-for-others';
import { AddInfluencerForTalentAgency } from './add-influencer-for-talent-agency';

export const AddInfluencer = () => {
  useUpdateDocumentTitle({
    href: '/influencers',
    alwaysBackToParent: true,
    title: 'documentTitle.AddInfluencer',
    appHeader: 'appHeader.Add New Influencer'
  });
  const { isTalentAgency, isAdminStaffPartner } = useUserRoles();

  return (
    <div>
      <Header />

      {isTalentAgency ? (
        <AddInfluencerForTalentAgency />
      ) : isAdminStaffPartner ? (
        <AddInfluencerForOthers />
      ) : (
        <Navigate to="/influencers" />
      )}
    </div>
  );
};
